export const userGuidelines = [
  {
    header: "Provide Accurate Information",
    answer:
      "When creating your account or interacting with other users, ensure that all information you provide is truthful and accurate. You must not create multiple, false, or misleading accounts.",
  },
  {
    header: "Post Appropriate Content",
    answer:
      "Refrain from sharing content or communications that are defamatory, offensive, illegal, or infringe upon the rights of others (including intellectual property, privacy, and publicity rights). Any content that is abusive, discriminatory, sexually explicit, or harassing in nature is strictly prohibited.",
  },
  {
    header: "Follow Legal and Ethical Standards",
    answer:
      "Use the platform responsibly and in compliance with all applicable laws. Do not engage in any fraudulent activities, discriminatory behavior, or conduct that could lead to legal penalties for you, other users, or the platform.",
  },
  {
    header: "Avoid Harmful Software",
    answer:
      "You may not upload or share files that contain viruses, malicious software, corrupted files, or other harmful programs that could compromise the integrity or security of others' devices.",
  },
  {
    header: "No Unauthorized Payments",
    answer:
      "Do not accept payments from third parties to conduct business activities on the platform unless you have received explicit authorization from the platform’s administrators.",
  },
  {
    header: "Respect Others' Accounts",
    answer:
      "Do not interfere with other users’ accounts or try to bypass any security measures set up to protect the platform. The use of bots, scrapers, or other automated tools to collect content or information is not allowed.",
  },
  {
    header: "Collect Data Responsibly",
    answer:
      "You must not gather or use personal information, including email addresses, without obtaining the necessary consent.",
  },
  {
    header: "No Rental Listings",
    answer:
      "The platform does not allow users to offer properties for rent. If your accommodation is listed on the platform, it must not be exchanged outside the platform's system.",
  },
  {
    header: "Abide by Additional Rules",
    answer:
      "Make sure to comply with any other rules or restrictions outlined in these guidelines.",
  },
  {
    header: "Responsibility for Use",
    answer:
      "You take full responsibility for your interactions, the information you share, and your use of the platform.",
  },
  {
    header: "Authority to Participate",
    answer:
      "You confirm that you have the necessary rights and authority to list your accommodation and participate in exchanges through this platform.",
  },
  {
    header: "Interactions with Others",
    answer:
      "You are solely responsible for managing your relationships and communications with other users.",
  },
  {
    header: "Monitoring and Cooperation",
    answer:
      "The platform may monitor user activities to ensure safety and compliance with these guidelines and legal requirements. You agree to cooperate with the platform's team if information or assistance is requested during an investigation.",
  },
  {
    header: "Reporting Misconduct",
    answer:
      "If you suspect that another user is violating these guidelines or engaging in illegal activities, you should promptly report this to the platform's support team and, if necessary, to the appropriate authorities. Note that reporting does not obligate the platform to take specific action unless required by law.",
  },
  {
    header: "Web and Contact Information",
    answer:
      "Any web addresses or URLs need prior approval from the platform before being included in listings. Email addresses and contact information should only be placed in designated areas. Unauthorized information may be removed without notice.",
  },
];
